export default {
  // Nav
  "nav.home": "Ana Sayfa",
  "nav.woonlening": "Konut Kredisi",
  "nav.loa": "Taksitli krediler",
  "nav.wieZijnWij": "Biz kimiz?",
  "nav.contact": "İletişim",

  // Footer
  "footer.partners": "Ortaklar",
  "footer.simuleer": "Kredinizi hesaplayın",
  "footer.juridisch": "Yasal bilgiler",
  "footer.privacy": "Gizlilik",
  "footer.hours": "Pzt - Cum: 9.00 - 12.30 & 13.30 - 18.00",
  "footer.saturday": "Cumartesi öğleden sonra randevu ile",
  "footer.rights": "MADE BY TEKDAM. ALL RIGHTS RESERVED.",

  // Home - Hero
  "home.hero.title": "",
  "home.hero.body": " - 1995'ten beri güvenilir kredi danışmanlığı",
  "home.hero.sub1": "Otuz yıldır bireyler ve serbest meslek sahipleri uzman ve kişisel kredi danışmanlığı için Haskrediet'e güveniyor.",
  "home.hero.sub1b": "Bugün sizin planlarınızı da gerçekleştirmek için hazırız.",
  "home.hero.sub2": "Sıradaki siz misiniz?",

  // Home - Simuleer
  "home.sim.title": "Kredinizi hesaplayın",
  "home.sim.subtitle": "Kredinizi birkaç tıklamayla hesaplayın",
  "home.sim.body": "Finansal olanaklarınızı bugün keşfedin. Haskrediet'in çevrimiçi simülasyonu ile ne kadar borç alabileceğinizi ve aylık geri ödemenizin ne olacağını saniyeler içinde hesaplayabilirsiniz. Hızlı, basit ve tamamen bağlayıcı olmayan. Böylece bütçeniz hakkında anında net bir görüş elde eder ve bir sonraki adımı iyi hazırlanmış olarak atabilirsiniz.",
  "home.sim.example": "Örnek:",
  "home.sim.exLine1": "Taksitli kredi - 48 ay boyunca 8.000 € borç alıyorsunuz",
  "home.sim.exLine2": "Aylık taksit: 183,86 € - Toplam geri ödeme: 8.825,28 €",
  "home.sim.jkp": "YYO:",
  "home.sim.rente": "Sabit veya değişken faiz oranı:",

  // Simulation type toggle
  "sim.type.woon": "Konut kredisi",
  "sim.type.loa": "Taksitli kredi",

  // Home - Loan card
  "loan.personalLoan": "Bireysel kredi",
  "loan.amount": "Tutar",
  "loan.duration": "Süre (ay)",
  "loan.monthly": "Aylık",
  "loan.months": "ay",
  "loan.personalCredit": "Bireysel kredi",
  "loan.maxAmount": "Maksimum tutar {max}'dir.",
  "loan.totalRepay": "Toplam geri ödeme",
  "loan.totalInterest": "Toplam faiz",
  "loan.chooseRateHint": "Simülasyonunuzu hesaplamak için bir faiz oranı seçin.",
  "loan.apply": "Başvur",
  "loan.onlineApply": "Çevrimiçi başvuru",

  // Contact form
  "contact.title": "İletişim formu",
  "contact.firstName": "Ad",
  "contact.lastName": "Soyad",
  "contact.email": "E-posta",
  "contact.phone": "Telefon numarası",
  "contact.send": "Gönder",
  "contact.bubble": "İletişimde kalalım",
  "contact.bubbleText": "Kredi çözümlerimiz hakkında daha fazla bilgi için formdaki bilgilerinizi bırakabilirsiniz. En kısa sürede sizinle iletişime geçeceğiz.",
  "contact.message": "Mesajınız:",
  "contact.success": "Mesajınız başarıyla gönderildi!",
  "contact.error": "Bir hata oluştu. Lütfen daha sonra tekrar deneyin.",

  // Woonlening
  "woon.title": "KONUT KREDİSİ",
  "woon.heroTitle": "Haskrediet - 1995'ten beri konut kredilerinde güvenilir ortağınız.",
  "woon.heroBody": "Kendi evinizi mi hayal ediyorsunuz?",
  "woon.heroText": "30 yılı aşkın deneyimiyle Haskrediet, durumunuza mükemmel uyan konut kredisine ulaşmanızda size rehberlik eder. Bağımsız danışmanlık, avantajlı koşullar ve başvurudan tapuya kadar kişisel rehberlik.",
  "woon.sim.title": "Konut kredinizi hesaplayın",
  "woon.sim.subtitle": "Aylık taksidinizi hesaplayın",
  "woon.sim.years": "yıl",
  "woon.startRequest": "Başvurunuzu başlatın",
  "woon.desiredAmount": "İSTENEN TUTAR",
  "woon.slogan": "Hayaliniz, bizim sorumluluğumuz.",
  "woon.val1": "Ev almak, yenilemek veya yeniden finanse etmek mi? {brand}'te her şey dinlemekle başlar. Sizin için gerçekten neyin önemli olduğunu anlamak istiyoruz: geleceğiniz, konforunuz, ritminiz...",
  "woon.val2": "Standart formüllere inanmıyoruz. Her kredi benzersizdir, çünkü her müşteri de öyledir. Bu yüzden bugün ve yarın durumunuza uyan bir çözüm bulmak için birlikte çalışıyoruz.",
  "woon.val3": "Uzmanlarımız size net tavsiyeler, adil koşullar ve insani bir yaklaşımla rehberlik eder.",
  "woon.val4": "Boş vaatler yok, net cevaplar ve gerçek bağlılık var.",
  "woon.cta": "{brand} ile kararlarınızı güvenle verirsiniz: adım adım, kendi hızınızda.",

  // Leningen
  "len.title": "TAKSİTLİ KREDİLER",
  "len.heroLine1": "Planlarınız size özel bir finansman hak ediyor.",
  "len.heroText1": "Yeni bir araba, tadilat, hayalinizdeki bir seyahat veya beklenmedik harcamalar olsun: bizimle ihtiyacınız olan finansal alana hızla sahip olursunuz. Durumunuzu birlikte değerlendirir, bütçenize ve gelecek planlarınıza mükemmel uyan bir çözüm ararız. Şeffaf, kişisel ve sürprizsiz.",
  "len.heroTagline": "Hızlıca halledilir. Net koşullar. Kişisel rehberlik.",
  "len.whatCanWeDo": "Sizin için ne yapabiliriz?",
  "len.personal": "Bireysel kredi",
  "len.personalDesc": "Kişisel bir proje, büyük bir satın alma veya beklenmedik bir harcama? Haskrediet'ten bireysel kredi ile planlarınızı endişesizce gerçekleştirin.",
  "len.auto": "Araç kredisi",
  "len.autoDesc": "Yeni veya ikinci el araba mı arıyorsunuz? Araç kredimizle hızlı ve uygun fiyatlı yola çıkın. Sizin hızınıza uygun rekabetçi finansman.",
  "len.reno": "Renovasyon kredisi",
  "len.renoDesc": "Evinizi yenilemek veya sürdürülebilir hale getirmek mi istiyorsunuz? Renovasyon kredimiz evinize ikinci bir hayat veriyor - bütçenize uygun.",
  "len.regroup": "Kredi birleştirme",
  "len.regroupDesc": "Birden fazla devam eden krediniz mi var? Hepsini tek bir net aylık ödemeye dönüştürüyoruz - genellikle daha avantajlı, her zaman daha net.",
  "len.chooseProject": "Projenizi seçin",
  "len.desiredAmount": "İstenen tutar",
  "len.paymentCount": "İstenen ödeme sayısı?",
  "len.clickHere": "Tıklayın",
  "len.dur": "Süre",
  "len.totalBack": "Toplam geri ödeme:",

  // Broker info
  "home.broker.title": "Neden Haskrediet'i seçmelisiniz?",
  "home.broker.intro1": "1995'ten bu yana Haskrediet, müşterilerine doğru kredi çözümünü bulmalarında rehberlik etmektedir. 30 yılı aşkın deneyimimizle güvenilir ve profesyonel bir kredi danışmanı olarak güçlü bir itibar oluşturduk.",
  "home.broker.intro2": "",
  "home.broker.troeven": "Güçlü yönlerimiz",
  "home.broker.ervaring.title": "Geniş deneyim ve uzmanlık",
  "home.broker.ervaring.text": "1995'ten beri kredi piyasasını yakından takip ediyoruz. Bu sayede müşterilerimize önemli finansal kararlarında uzman danışmanlık ve rehberlik sunabiliyoruz.",
  "home.broker.persoonlijk.title": "Kişisel yaklaşım",
  "home.broker.persoonlijk.text": "İsteklerinizi dinliyor, durumunuzu analiz ediyor ve ihtiyaçlarınıza mükemmel şekilde uyan bir çözüm arıyoruz.",
  "home.broker.onafhankelijk.title": "Bağımsız danışmanlık",
  "home.broker.onafhankelijk.text": "Bir kredi danışmanı olarak farklı kredi sağlayıcılarını karşılaştırıyoruz. Böylece profilinize en uygun koşullarla bir formül bulmanıza yardımcı oluyoruz.",
  "home.broker.begeleiding.title": "Eksiksiz rehberlik",
  "home.broker.begeleiding.text": "İlk başvurudan dosyanızın nihai işlemine kadar yanınızdayız. Tüm süreç boyunca net iletişim ve profesyonel desteğe güvenebilirsiniz.",
  "home.broker.vertrouwen.title": "Güven ve şeffaflık",
  "home.broker.vertrouwen.text": "Otuz yılı aşkın süredir müşteriler dürüst yaklaşımımız, şeffaf bilgilendirmemiz ve güvenilir hizmetimiz nedeniyle Haskrediet'i tercih ediyor.",
  "home.broker.aanbod.title": "Geniş ürün yelpazesi",
  "home.broker.aanbod.text": "Konut kredilerinden bireysel kredilere, leasingden ticari kredilere kadar: Haskrediet'te tüm finansman çözümlerini tek çatı altında bulabilirsiniz.",
  "home.broker.closing.title": "30 yılı aşkın deneyim sizin avantajınıza",
  "home.broker.closing.text": "Haskrediet olarak iyi bir kredi danışmanlığının müşteriyi dinlemekle başladığına inanıyoruz. Bu nedenle her gün deneyim, uzmanlık ve kişisel hizmetle desteklenen özel finansal çözümler sunmak için çalışıyoruz.",
  "home.broker.closing.tagline": "Haskrediet - 1995'ten beri güvenilir kredi ortağınız.",

  // Simulation info
  "home.sim.free": "Ücretsiz simülasyonunuzu başlatın - bu tamamen bağlayıcı değildir ve herhangi bir yükümlülük içermez.",

  // Loan calculator
  "loan.rate": "Yıllık faiz oranı (%)",
  "loan.amountInfo.woon": "Konut kredisi için istenen tutar 25.000 € ile 3.000.000 € arasındadır.",
  "loan.amountInfo.loa": "Taksitli kredi için istenen tutar 500 € ile 99.999,99 € arasındadır.",
  "loan.durationInfo.woon": "Konut kredisinin süresi 5 ile 30 yıl arasındadır.",
  "loan.durationInfo.loa": "Süre, ödünç alınan tutara bağlıdır:",
  "loan.durationTable.amount": "Tutar",
  "loan.durationTable.maxDuration": "Maks. süre",
  "loan.durationTable.above": "Üstü",
  "loan.rateInfo": "Simülasyonunuz için faiz oranını burada kendiniz belirlersiniz. Bu kesin oran değildir. Gerçek yüzde çeşitli faktörlere bağlıdır ve HASKREDIET'in kişisel danışmanlığından sonra belirlenecektir.",

  // Footer
  "footer.maps": "YOL TARİFİ",

  // Verzekeringen
  "nav.verzekeringen": "Sigortalar",
  "verz.title": "SİGORTALAR",
  "verz.intro": "Kredi çözümlerinin yanı sıra kapsamlı bir sigorta yelpazesi de sunuyoruz. Tam teklifimizi sigorta sayfamızda keşfedin.",
  "verz.link": "Haskrediet Sigortalar'a git",

  // Leasing
  "nav.leasing": "Leasing",
  "leasing.title": "LEASING BAŞVURUSU",
  "leasing.heroTitle": "Bugün yatırım yapın, taksitli ödeyin",
  "leasing.heroText": "Mevcut sermayenizi kullanmadan araç, kamyonet, makine veya profesyonel ekipman finanse etmek mi istiyorsunuz? Haskrediet aracılığıyla leasing ile işletmenize tam uygun, esnek ve vergi açısından avantajlı bir çözümden yararlanın.",
  "leasing.whyTitle": "Neden Haskrediet ile leasing?",
  "leasing.why1": "Dosyanızın hızlı ve kişisel olarak işlenmesi",
  "leasing.why2": "İşletmenize özel finansman",
  "leasing.why3": "İşletme sermayenizin ve mali alanınızın korunması",
  "leasing.why4": "Sözleşme sonunda satın alma imkanı",
  "leasing.why5": "Şeffaf koşullar, sürprizsiz",
  "leasing.why6": "Finansal çözümlerde 30 yılı aşkın deneyim",
  "leasing.whatTitle": "Hangi yatırımlar için?",
  "leasing.whatIntro": "Aşağıdaki leasing işlemlerinde size rehberlik ediyoruz:",
  "leasing.what1": "Binek otomobiller ve şirket araçları",
  "leasing.what2": "Kamyonetler ve kamyonlar",
  "leasing.what3": "Makineler ve üretim ekipmanları",
  "leasing.what4": "İnşaat ve tarım ekipmanları",
  "leasing.what5": "BT ve ofis ekipmanları",
  "leasing.what6": "Tıbbi ve profesyonel ekipman",
  "leasing.customTitle": "Faaliyetinize uygun bir çözüm",
  "leasing.customText": "Her işletme benzersizdir. Bu nedenle ihtiyaçlarınıza, bütçenize ve büyüme planlarınıza en uygun leasing formülünü birlikte değerlendiriyoruz.",
  "leasing.customTagline": "Hızlı, uzman ve kişisel rehberlik.",
  "leasing.ctaTitle": "Leasing başvurunuzu bağlayıcı olmadan yapın",
  "leasing.ctaText": "Yatırımınız için hangi olanakların mevcut olduğunu öğrenmek ister misiniz? Uzmanlarımız size danışmanlık yapmaya ve özel bir teklif hazırlamaya hazır.",
  "leasing.ctaClosing": "Bugün leasing başvurunuzu yapın ve profesyonel planlarınızı güvenle gerçekleştirin.",
  "leasing.ctaTagline": "Haskrediet - 1995'ten beri güvenilir finansman ortağınız.",
  "leasing.contactBtn": "Bize ulaşın",
  "leasing.formSubject": "Yeni leasing başvurusu - Haskrediet",

  // Ondernemers
  "nav.ondernemers": "Girişimciler",
  "ond.title": "TİCARİ & YATIRIM KREDİLERİ",
  "ond.heroTitle": "İşletmenize büyüme alanı verin",
  "ond.heroText1": "İşletmenizin geleceğine yatırım yapmak mı istiyorsunuz? Haskrediet aracılığıyla ticari kredi veya yatırım kredisi ile likiditinizi riske atmadan planlarınızı gerçekleştirecek finansal kaynaklara sahip olursunuz.",
  "ond.heroText2": "İster yeni başlıyor, ister büyüyor, ister modernize ediyor olun, işletmenizin hedeflerine uygun bir finansman çözümü ile size rehberlik ediyoruz.",
  "ond.whatTitle": "Yatırım kredisini ne için kullanabilirsiniz?",
  "ond.what1": "İş yeri alımı veya tadilatı",
  "ond.what2": "Makineler ve üretim ekipmanları",
  "ond.what3": "Araçlar ve şirket arabaları",
  "ond.what4": "BT altyapısı ve dijitalleşme",
  "ond.what5": "Faaliyetlerinizin genişletilmesi",
  "ond.what6": "İş devralma",
  "ond.what7": "Profesyonel ekipman finansmanı",
  "ond.what8": "İşletme sermayenizin güçlendirilmesi",
  "ond.whyTitle": "Neden Haskrediet?",
  "ond.adv1.title": "Kişiye özel danışmanlık",
  "ond.adv1.text": "Her işletme benzersizdir. Bu nedenle faaliyetinize ve gelecek planlarınıza uygun finansman çözümünü birlikte arıyoruz.",
  "ond.adv2.title": "30 yılı aşkın deneyim",
  "ond.adv2.text": "1995'ten beri serbest meslek sahiplerine, KOBİ'lere ve girişimcilere uzman ve bağımsız danışmanlık sunuyoruz.",
  "ond.adv3.title": "Hızlı ve verimli işlem",
  "ond.adv3.text": "Dosyanızı özenle analiz ediyor ve sorunsuz takip sağlıyoruz, böylece işletmenize odaklanabilirsiniz.",
  "ond.adv4.title": "Şeffaf koşullar",
  "ond.adv4.text": "Net anlaşmalar ve olanaklarınıza ve hedeflerinize uygun finansman.",
  "ond.closingTitle": "Güvenle yatırım yapın. Kesinlikle büyüyün.",
  "ond.closingText": "Güçlü bir işletme, güçlü bir finansal partner hak eder. Haskrediet, profesyonel danışmanlık ve özel çözümlerle yatırım projelerinizi gerçekleştirmenize yardımcı olur.",
  "ond.closingCta": "Bugün bağlayıcı olmadan ticari kredinizi veya yatırım kredinizi talep edin.",
  "ond.closingTagline": "Haskrediet - 30 yılı aşkın süredir girişimciler ve serbest meslek sahipleri için güvenilir ortak.",
  "ond.contactBtn": "Bize ulaşın",
  "ond.formSubject": "Yeni ticari kredi başvurusu - Haskrediet",

  // Wie zijn wij
  "wie.title": "BİZ KİMİZ?",
  "wie.heroIntro1": "Bir kredi danışmanı olarak bireylere ve girişimcilere en uygun finansman çözümünü bulmalarında rehberlik ediyoruz. Bağımsız konumumuz sayesinde farklı kredi sağlayıcılarını karşılaştırıyor ve mali durumunuza, isteklerinize ve gelecek planlarınıza uygun bir formül arıyoruz.",
  "wie.heroIntro2": "Bir kredinin sadece bir borçlanmadan ibaret olmadığına inanıyoruz. Bu, uzman danışmanlık, şeffaflık ve kişisel rehberlik gerektiren önemli bir finansal karardır. Bu nedenle dosyanızı derinlemesine analiz etmek ve tüm seçenekleri açıkça anlatmak için zaman ayırıyoruz.",
  "wie.heroIntro3": "İster konut kredisi, ister yeniden finansman, yatırım kredisi veya başka bir finansman ihtiyacı olsun, ilk simülasyondan nihai imzaya kadar tüm süreç boyunca yanınızdayız.",
  "wie.values.title": "Temel değerlerimiz:",
  "wie.values.onafhankelijk": "Bağımsız danışmanlık: sizin için en iyi çözümü bulmak amacıyla farklı sağlayıcıları karşılaştırıyoruz.",
  "wie.values.begeleiding": "Kişisel rehberlik: her müşteri ve her dosya benzersizdir.",
  "wie.values.transparantie": "Şeffaflık: sürprizsiz, açık iletişim.",
  "wie.values.deskundigheid": "Uzmanlık: kredi piyasası ve finansal düzenlemeler hakkında güncel bilgi.",
  "wie.closing1": "Bir kredi danışmanı olarak finansmanı erişilebilir, anlaşılır ve sorunsuz hale getirmeyi hedefliyoruz. Böylece doğru finansal kararları güvenle verebilirsiniz.",
  "wie.closing2": "Kredi Danışmanı - kişiye özel kredi danışmanlığında güvenilir ortağınız.",

  // Juridische mededeling
  "jur.title": "YASAL BİLDİRİM",
  "jur.companyTitle": "Şirket bilgileri",
  "jur.btwLabel": "KDV",
  "jur.activityTitle": "Faaliyet",
  "jur.activityText": "HASKREDIET BV, konut kredisi ve tüketici kredisi aracısı olarak faaliyet göstermektedir. Kredi danışmanı olarak farklı kredi sağlayıcılarının tekliflerini karşılaştırarak müşterilerimiz için en uygun finansman çözümünü buluyoruz.",
  "jur.fsmaTitle": "Denetim otoritesi",
  "jur.fsmaText": "HASKREDIET BV, konut kredisi ve tüketici kredisi aracısı olarak FSMA (Finansal Hizmetler ve Piyasalar Otoritesi), Rue du Congrès 12-14, 1000 Brüksel'e kayıtlıdır.",
  "jur.fsmaCheck": "Kaydımızı FSMA web sitesinden doğrulayabilirsiniz: www.fsma.be.",
  "jur.disclaimerTitle": "Sorumluluk reddi",
  "jur.disclaimerText1": "Bu web sitesindeki bilgiler tamamen bilgilendirme amaçlıdır ve bir kredi teklifi oluşturmaz. Her kredi başvurusu bireysel olarak değerlendirilir ve kredi sağlayıcının onayına tabidir.",
  "jur.disclaimerText2": "Bu web sitesindeki simülasyonlar gösterge niteliğindedir ve bağlayıcı değildir. Kişisel durumunuzun analizi sonrasında gerçek koşullar farklılık gösterebilir.",
  "jur.liabilityTitle": "Sorumluluk",
  "jur.liabilityText1": "HASKREDIET BV bu web sitesinin içeriğine büyük özen gösterir, ancak sağlanan bilgilerin eksiksizliğini, doğruluğunu veya güncelliğini garanti edemez.",
  "jur.liabilityText2": "HASKREDIET BV, bu web sitesinin kullanımından veya üzerinde sunulan bilgilerden kaynaklanan olası zararlardan sorumlu tutulamaz.",
  "jur.ipTitle": "Fikri mülkiyet",
  "jur.ipText": "Bu web sitesindeki tüm metinler, görseller, logolar ve diğer unsurlar telif hakkı ile korunmaktadır ve HASKREDIET BV'nın önceden yazılı izni olmadan çoğaltılamaz, dağıtılamaz veya kullanılamaz.",
  "jur.disputeTitle": "Uyuşmazlıklar",
  "jur.disputeText": "Bu yasal bildirim ve bu web sitesinin kullanımı Belçika hukuku tabidir. Olası uyuşmazlıklar münhasıran Gent mahkemelerinin yetki alanına girer.",

  // Privacy
  "priv.title": "GİZLİLİK POLİTİKASI",
  "priv.intro": "HASKREDIET BV, kişisel verilerinizin korunmasına büyük önem vermektedir. Bu gizlilik politikası, Genel Veri Koruma Yönetmeliği (GDPR) uyarınca hangi verileri topladığımızı, neden topladığımızı ve gizliliğinizi nasıl koruduğumuzu açıklamaktadır.",
  "priv.controllerTitle": "Veri sorumlusu",
  "priv.dataTitle": "Hangi verileri topluyoruz?",
  "priv.dataText": "Bizimle iletişime geçtiğinizde veya başvuru yaptığınızda aşağıdaki kişisel verileri toplayabiliriz:",
  "priv.data1": "Ad ve soyad",
  "priv.data2": "E-posta adresi",
  "priv.data3": "Telefon numarası",
  "priv.data4": "İletişim formu aracılığıyla gönderilen mesajlar",
  "priv.purposeTitle": "Verilerinizi ne için kullanıyoruz?",
  "priv.purposeText": "Kişisel verileriniz yalnızca aşağıdaki amaçlarla kullanılmaktadır:",
  "priv.purpose1": "Sorularınıza ve taleplerinize yanıt vermek",
  "priv.purpose2": "Kredi ve finansman çözümleri hakkında danışmanlık sağlamak",
  "priv.purpose3": "Dosyanızın takibini yapmak",
  "priv.legalTitle": "Hukuki dayanak",
  "priv.legalText": "Kişisel verilerinizin işlenmesi, rızanıza (iletişim formunu doldururken) ve bir sözleşmenin ifasına veya sözleşme öncesi tedbirlere dayanmaktadır.",
  "priv.retentionTitle": "Saklama süresi",
  "priv.retentionText": "Kişisel verileriniz, toplandıkları amaçlar için gerekli olandan daha uzun süre saklanmaz, yasal olarak daha uzun bir saklama süresi gerekli olmadıkça.",
  "priv.sharingTitle": "Veri paylaşımı",
  "priv.sharingText": "Kişisel verilerinizi, hizmetlerimizin yürütülmesi için gerekli olmadıkça (örneğin bir kredi başvurusunda kredi sağlayıcıyla) veya yasal olarak zorunlu olmadıkça üçüncü taraflarla paylaşmıyoruz.",
  "priv.rightsTitle": "Haklarınız",
  "priv.rightsText": "Her zaman aşağıdaki haklara sahipsiniz:",
  "priv.right1": "Kişisel verilerinize erişim talep etmek",
  "priv.right2": "Verilerinizin düzeltilmesini veya tamamlanmasını istemek",
  "priv.right3": "Verilerinizin silinmesini istemek",
  "priv.right4": "Verilerinizin işlenmesini kısıtlamak",
  "priv.right5": "Verilerinizin işlenmesine itiraz etmek",
  "priv.rightsContact": "Haklarınızı info@haskrediet.be adresinden veya 09/267.30.30 numarasından bize ulaşarak kullanabilirsiniz.",
  "priv.cookieTitle": "Çerezler",
  "priv.cookieText": "Bu web sitesi, kullanıcı deneyimini iyileştirmek için çerezler kullanabilir. Web sitesini kullanmaya devam ederek çerezlerin kullanımını kabul etmiş olursunuz.",
  "priv.changeTitle": "Değişiklikler",
  "priv.changeText": "HASKREDIET BV, bu gizlilik politikasını herhangi bir zamanda değiştirme hakkını saklı tutar. En güncel sürüm her zaman bu sayfada mevcuttur.",

  // Disclaimer
  "loan.disclaimer": "Kredi, dosya onayına tabidir",

  // Global
  "global.loanCost": "Dikkat, borç almak da paraya mal olur.",
} as Record<string, string>;
